import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const extModules = [
  StoreDevtoolsModule.instrument({
    name: 'ToReserve',
    connectInZone: true,
  }),
];
